/* Towel BOGO campaign — quantity-aware nudge.
   Watches the theme's quantity field inside [data-towel-form] and swaps the
   nudge copy at qty 1 vs 2+. The quick-quantity buttons (2/4/6/10) set the
   quantity through the same input the theme's cart JS reads, so the submitted
   quantity matches. The BOGO applies per pair (verified in cart), so the
   done-message computes [free] = floor(qty/2) and [pay] = qty - free.
   No storage APIs, no MutationObserver. */
(function () {
  'use strict';

  function initForm(form) {
    if (form.hasAttribute('data-towel-init')) return;

    var nudge = form.querySelector('[data-bogo-nudge]');
    var qty = form.querySelector('[data-quantity-field]');
    if (!nudge || !qty) return;

    form.setAttribute('data-towel-init', '');

    var textEl = nudge.querySelector('[data-bogo-nudge-text]');
    var optButtons = Array.prototype.slice.call(nudge.querySelectorAll('[data-bogo-set-qty]'));
    var popout = qty.closest('[data-popout]');
    var popoutToggle = popout ? popout.querySelector('[data-popout-toggle]') : null;

    function render() {
      var q = parseInt(qty.value, 10) || 1;
      var done = q >= 2;
      var msg;

      if (done) {
        var free = Math.floor(q / 2);
        var pay = q - free;
        msg = (nudge.getAttribute('data-msg-done') || '')
          .replace(/\[qty\]/g, q)
          .replace(/\[free\]/g, free)
          .replace(/\[pay\]/g, pay);
      } else {
        msg = nudge.getAttribute('data-msg-add-one');
      }

      nudge.classList.toggle('towel-bogo-nudge--done', done);
      if (textEl && textEl.textContent !== msg) textEl.textContent = msg;

      optButtons.forEach(function (b) {
        var v = parseInt(b.getAttribute('data-bogo-set-qty'), 10);
        b.setAttribute('aria-pressed', v === q ? 'true' : 'false');
      });
    }

    function renderSoon() {
      window.requestAnimationFrame(render);
      window.setTimeout(render, 120);
    }

    qty.addEventListener('change', render);
    qty.addEventListener('input', render);

    // The theme's +/- buttons and the qty popout set the input value
    // programmatically, so also re-check after any click on them.
    form.addEventListener('click', function (e) {
      if (e.target.closest('[data-quantity-button], [data-popout-option]')) {
        renderSoon();
      }
    });

    optButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(b.getAttribute('data-bogo-set-qty'), 10) || 2;
        qty.value = v;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
        if (popoutToggle) popoutToggle.textContent = String(v);
        render();
      });
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-towel-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section reloads in the Theme Editor.
  document.addEventListener('shopify:section:load', initAll);
})();
